import { Component, OnInit, OnDestroy, DOCUMENT, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { TranslateDirective } from '@ngx-translate/core';

import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { DetailedLoadingIndicatorComponent } from '../../components/detailed-loading-indicator/detailed-loading-indicator.component';
import { HelpArticleIndexComponent } from './help-article-index.component';
import { HelpDesktopArticleComponent } from './help-desktop-article.component';
import { HelpScrollerDirective } from './help-scroller.directive';
import { HelpBaseComponent } from './help-base.component';
import { ImageLoadDirective } from './image-load.directive';

@Component({
  selector: 'td-wb-help-desktop',
  templateUrl: 'help-desktop.component.html',
  styleUrls: ['help-common.scss', 'help-desktop.component.scss'],
  imports: [
    ButtonComponent,
    TranslatePipe,
    TranslateDirective,
    IconComponent,
    HelpScrollerDirective,
    HelpArticleIndexComponent,
    HelpDesktopArticleComponent,
    ImageLoadDirective,
    DetailedLoadingIndicatorComponent
  ]
})
export class HelpDesktopComponent extends HelpBaseComponent implements OnInit, OnDestroy {
  private readonly document = inject<Document>(DOCUMENT);

  private static DEBOUNCE_DELAY: number = 30;

  private readonly imageLoad: Subject<void> = new Subject<void>();

  skipToContent(articleId: string): false {
    const element = this.document.getElementById(articleId);
    if (element !== undefined && element !== null) {
      element.focus();
    }
    return false;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.imageLoad
      .pipe(
        debounceTime(HelpDesktopComponent.DEBOUNCE_DELAY),
        takeUntil(this.destroy)
      )
      .subscribe((): void => {
        this.firstLoad = true;
        this.setScrollPostion();
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onImageLoaded(): void {
    this.imageLoad.next();
  }

  hasFocus(id: string): boolean {
    return id === this.articleId;
  }
}
